// composables/useTracking.ts
export const useTracking = () => {
  const getTrackingContext = () => {
    if (process.server) {
      return { source_page: 'server', current_page: 'server' };
    }
    
    return {
      source_page: window.__trackingContext?.source_page || 'unknown',
      current_page: window.__trackingContext?.current_page || 'unknown'
    };
  };

  return {
    getTrackingContext
  };
};